import { Link } from 'react-router-dom';
import { SITE } from '../../../config/site';
import { SearchBar } from '../../ui/SearchBar';
import styles from './Header.module.css';

export function Header() {
  return (
    <header className={styles.header}>
      <div className="container">
        <div className={styles.mainRow}>
          <Link to="/" className={styles.logo}>
            <img src="/logo.png" alt={SITE.name} className={styles.logoImage} />
          </Link>

          <Link to="/catalog" className={styles.catalogBtn}>
            <MenuIcon />
            <span>Каталог</span>
          </Link>

          <SearchBar className={styles.search} />
        </div>

        <div className={styles.subRow}>
          <div className={styles.info}>
            <a
              href={SITE.mapsUrl}
              className={`${styles.infoItem} ${styles.infoItemAddress}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PinIcon />
              <span className={styles.infoText}>{SITE.address}</span>
            </a>
            <span className={`${styles.infoItem} ${styles.infoItemHours}`}>
              <ClockIcon />
              {SITE.hours}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}

function MenuIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7" rx="1" fill="currentColor" />
      <rect x="14" y="3" width="7" height="7" rx="1" fill="currentColor" />
      <rect x="3" y="14" width="7" height="7" rx="1" fill="currentColor" />
      <rect x="14" y="14" width="7" height="7" rx="1" fill="currentColor" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1112 6a2.5 2.5 0 010 5.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
      <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
